export type Environment = 'production' | 'homolog';

// Versão da aplicação
export const APP_VERSION = '3.2.12';

// Paths usados pelo proxy do Vite em dev (vite.config.ts server.proxy).
// Em dev o app usa esses paths relativos; o Vite encaminha para os backends.
const PROXY_API_PATH = '/39dd54c0-9ea1-4708-a9c5-5120810b3b72/';
const PROXY_ADSERVER_PATH = '/39dd54c0-9ea1-4708-a9c5-5120810b3b72/adserver/';
const PROXY_HE_PATH = '/identify/v2/';

const config = {
  production: {
    apiBaseUrl: 'https://api.vivofree.com.br/39dd54c0-9ea1-4708-a9c5-5120810b3b72/',
    adserverBaseUrl: 'https://api.vivofree.com.br/39dd54c0-9ea1-4708-a9c5-5120810b3b72/adserver/',
    headerEnrichmentUrl: 'https://mdivo.terra.com.br/identify/v2/',
    ga4MeasurementId: 'G-XR6NQW6L1M'
  },
  homolog: {
    apiBaseUrl: 'https://api.vivofree.com.br/39dd54c0-9ea1-4708-a9c5-5120810b3b72/',
    adserverBaseUrl: 'https://api.vivofree.com.br/39dd54c0-9ea1-4708-a9c5-5120810b3b72/adserver/',
    headerEnrichmentUrl: 'https://mdivo.terra.com.br/identify/v2/',
    ga4MeasurementId: 'G-XR6NQW6L1M'
  }
};

const currentEnv: Environment = (import.meta.env.VITE_ENV as Environment) || 'homolog';
const isDev = import.meta.env.DEV === true;

/** Paths do proxy (para uso no banner quando useProxy e a página não passa apiBaseUrl). */
export const proxyPaths = {
  api: PROXY_API_PATH,
  headerEnrichment: PROXY_HE_PATH
};

const base = config[currentEnv];
export const environment = {
  ...base,
  apiBaseUrl: isDev ? PROXY_API_PATH : base.apiBaseUrl,
  adserverBaseUrl: isDev ? PROXY_ADSERVER_PATH : base.adserverBaseUrl,
  headerEnrichmentUrl: isDev ? PROXY_HE_PATH : base.headerEnrichmentUrl
};
export const isProduction = currentEnv === 'production';

